import { User, UserManager, UserManagerSettings } from 'oidc-client';
import AuthorizationResult from '../../types/authorization/AuthorizationResult';
import identityStorage from './identityStorage';
import resolveConfig from '../configuration/resolveConfig';
import typeHelper from '../helpers/common/typeHelper';
import { sessionExpireCheck } from '../../components/App.Helpers';
import SessionExpireState from '../../components/Common/SessionExpire/SessionExpireState';
import actions from '../../store/actions';
import store from '../../store/store';

const config = resolveConfig();

const settings: UserManagerSettings = {
    client_id: 'control-box-ui',
    authority: config.identity.authority,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    redirect_uri: window.location.origin + '/login',
    post_logout_redirect_uri: window.location.origin + '/login',
    response_type: 'code',
    scope: "openid profile control-box offline_access",
    prompt: 'login',
    silentRequestTimeout: 10000,
    monitorSession: false
};

const manager = new UserManager(settings);

const onLoginSuccess = (user: User): void => {
    identityStorage.set(user);

    localStorage.reportConfigSearchText = '';
    localStorage.ingestionConfigSearchText = '';

    const intervalId = store.getState().sessionExpireState.intervalId;

    window.clearInterval(intervalId);

    store.dispatch({ type: actions.sessionExpire.intervalId, payload: { intervalId: null } });
    store.dispatch({ type: actions.sessionExpire.warningShowned, payload: { warningShowned: false } as SessionExpireState });

    checkSessionExpiration();
};

const loginRedirect = (): void => {

    manager.clearStaleState().then(() => manager.signinRedirect());
};

const loginComplete = async (): Promise<void> => {

    let res = await manager.signinRedirectCallback();

    return onLoginSuccess(res);
}

const logoutRedirect = (): void => {
    identityStorage.clear();
    manager.signoutRedirect();
};

const authorize = (): AuthorizationResult => {
    let identity = identityStorage.get();

    if (!typeHelper.isString(identity.accessToken)) {

        return unauthorized();
    }

    if (identity.expirationTimestampIso > new Date().toISOString()) {

        return { authorized: true, role: identity.userRole };
    }

    identityStorage.clear();

    return unauthorized();
};

const unauthorized = (): AuthorizationResult => {

    return { authorized: false } as AuthorizationResult;
};

const checkSessionExpiration = () => {

    const oneMinutesInMileseconds = 60000;

    setInterval(() => {

        sessionExpireCheck();
    }, oneMinutesInMileseconds);
}

const trySignInSilent = async () => {

    try {
        const user = await manager.signinSilent();

        onLoginSuccess(user);
    }
    catch (error) {
        manager.signinRedirect();
    }
}
const identityProvider = {
    loginRedirect,
    loginComplete,
    logoutRedirect,
    authorize,
    trySignInSilent
};

export default identityProvider;
